module.exports = __webpack_public_path__ + "static/ue-0ce806f8023db2c98fc3218a73b94d15.png";